import {useSelector} from "react-redux";
import {IReduxState} from "ReduxStrc/IReduxState";

const useProfile = () => {
    return useSelector((state: IReduxState) => ({profile: state.firebase.profile})).profile;
};

export default useProfile;